import { TextField } from '@mui/material'
import { CustomInputAdornment } from '@tom-ui/ui'
import { FieldStoreProps } from '@tom-ui/utils'

type NumberFieldWithUnitProps<T> = {
  id?: string
  name: string
  label: string
  unit: string
  fieldStoreProps: FieldStoreProps<T>
  disabled?: boolean
  onChange?: (value: T) => void
  restrictionMode?: NumberFieldRestrictionType
}

export const preventPasteKeys = (
  e: React.ClipboardEvent<HTMLDivElement>,
  restrictionMode: NumberFieldRestrictionType,
) => {
  const { clipboardData } = e
  const textData = clipboardData.getData('text')
  if (textData.includes('e') || textData.includes('E') || textData.includes('+')) {
    e.preventDefault()
    return
  }

  if (restrictionMode === 'nonNegative') {
    const parsedData = parseFloat(textData)

    if (parsedData < 0) {
      e.preventDefault()
    }
  }
}

export const preventKeys = (
  e: React.KeyboardEvent<HTMLDivElement>,
  restrictionMode: NumberFieldRestrictionType,
) => {
  if (e.key === 'e' || e.key === 'E' || e.key === '+') {
    e.preventDefault()
  }

  if (restrictionMode === 'nonNegative' && e.key === '-') {
    e.preventDefault()
  }
}

export type NumberFieldRestrictionType = 'nonNegative' | 'none'
export const NumberFieldWithUnit = <T,>({
  id,
  name,
  label,
  unit,
  fieldStoreProps,
  disabled,
  onChange,
  restrictionMode = 'none',
}: NumberFieldWithUnitProps<T>) => {
  return (
    <TextField
      {...fieldStoreProps}
      id={id}
      data-cy={`${name}-input`}
      name={name}
      label={label}
      disabled={disabled}
      type='number'
      fullWidth
      variant='outlined'
      slotProps={{
        input: {
          endAdornment: (
            <CustomInputAdornment position='end' color='secondary'>
              {unit}
            </CustomInputAdornment>
          ),
        },
        htmlInput: { min: restrictionMode === 'nonNegative' ? 0 : undefined },
      }}
      onKeyDown={e => preventKeys(e, restrictionMode)}
      onChange={event => {
        fieldStoreProps.onChange?.(event)
        onChange?.(event.target.value as T)
      }}
      onPaste={e => preventPasteKeys(e, restrictionMode)}
      onWheel={event => event.target instanceof HTMLElement && event.target.blur()}
    />
  )
}
